export const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent);

    // iOS detection
    if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // Default to desktop/other
    return 'desktop';
};